/**
 * Crud
 *
 * @author edmsamuel
 */
import React from 'react';
import { Button, Tooltip, Popconfirm  } from 'antd';

export default class Crud extends React.Component {
  /**
   * Render
   */
  render() {
    const buttons = this.props.buttons || ['add', 'edit', 'save', 'cancel', 'delete', 'reload'];
    const showButtons = {
      add: buttons.indexOf('add') > -1,
      edit: buttons.indexOf('edit') > -1,
      save: buttons.indexOf('save') > -1,
      cancel: buttons.indexOf('cancel') > -1,
      delete: buttons.indexOf('delete') > -1,
      reload: buttons.indexOf('reload') > -1,
    }

    return (
      <Button.Group>
        {/* add */}
        {showButtons.add ? (
            <Tooltip key='__add' title='Nuevo'>
              <Button icon='plus' onClick={this.props.onAdd} />
            </Tooltip>
          ): null
        }

        {/* edit */}
        {showButtons.edit ? (
            <Tooltip key='__edit' title='Editar'>
              <Button icon='edit' onClick={this.props.onEdit} />
            </Tooltip>
          ) : null
        }

        {/* save */}
        {showButtons.save ? (
            <Tooltip key='__save' title='Guardar'>
              <Button icon='save' onClick={this.props.onSave} />
            </Tooltip>
          ) : null
        }

        {/* cancel */}
        {showButtons.cancel ? (
            <Tooltip key='__cancel' title='Cancelar'>
              <Button icon='undo' onClick={this.props.onCancel} />
            </Tooltip>
          ) : null
        }

        {/* delete */}
        {showButtons.delete ? (
            <Tooltip key='__delete' title='Eliminar'>
            {this.props.deleteConfirmation === false ? (
                <Button icon='delete' onClick={this.props.onDelete} />
              ) : (
                <Popconfirm title='¿Eliminar?' onConfirm={this.props.onDelete}>
                  <Button icon='delete' />
                </Popconfirm>
              )
            }
            </Tooltip>
          ) : null
        }

        {/* refresh */}
        {showButtons.reload ? (
            <Tooltip key='__reload' title='Actualizar'>
              <Button icon='reload' onClick={this.props.onReload} />
            </Tooltip>
          ) : null
        }

        {/* children */}
        {this.props.children}
      </Button.Group>
    );
  }
}
